import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'customDate',
    standalone: false
})
export class CustomDatePipe implements PipeTransform {

  transform(value: Date | string): string {
    if (!value) return '';
    const date = typeof value === 'string' ? new Date(value + 'Z') : value;
    const dtStr = this.formatDate(date);
    const tmStr = this.formatTime(date);
    return dtStr + ' kl ' + tmStr;
  }

  formatDate(date: Date): string {
    return new Intl.DateTimeFormat('nb-NO', {
      timeZone: 'Europe/Oslo',
      year: '2-digit',
      month: '2-digit',
      day: '2-digit',
    }).format(date);
  }

  formatTime(date: Date): string {
    return new Intl.DateTimeFormat('nb-NO', {
      timeZone: 'Europe/Oslo',
      hour: '2-digit',
      minute: '2-digit',
    }).format(date);
  }

}
